import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../CoreWrappers/Button';
import Dropdown from '../../CoreWrappers/Dropdown';
import StyledPspIndexCount from './StyledPspIndexCount';

const PspIndexCountDropdown = ({itemList, activeLabel, headerText, triggerSize, ...rest}) => {
	const renderTrigger = () => {
		return (
			<Button size={triggerSize} variant="text-alt" title={headerText}>
				{activeLabel}
			</Button>
		);
	};

	const renderPlainText = () => (
		<OutputText className="no-items" body2 ellipsis title={headerText}>
			{activeLabel}
		</OutputText>
	);

	const renderItem = ({id, label}) => {
		const props = {
			key: id,
			title: label,
			maxWidth: 'var(--px-240)',
			light: true,
			ellipsis: true,
			useTypography: false
		};

		return <OutputText {...props}>{label}</OutputText>;
	};

	const items = itemList
		?.sort((a, b) =>
			a.pspIndexTitle?.toLowerCase().localeCompare(b.pspIndexTitle?.toLowerCase(), undefined, {
				numeric: true,
				sensitivity: 'base'
			})
		)
		.map(({pspIndexID, pspIndexTitle}) => {
			return {
				id: pspIndexID,
				label: pspIndexTitle,
				customRender: renderItem,
				type: 'container'
			};
		});

	const props = {
		...rest,
		placement: 'bottom-right',
		trigger: renderTrigger(),
		items,
		topfix: true,
		maxItems: 6,
		itemSize: 40,
		header: () => <OutputText ellipsis>{headerText}</OutputText>,
		onClick: (e) => {
			e.stopPropagation();
		}
	};

	return (
		<StyledPspIndexCount>
			{itemList?.length > 0 && <Dropdown {...props} />}
			{itemList?.length === 0 && renderPlainText()}
		</StyledPspIndexCount>
	);
};

PspIndexCountDropdown.propTypes = {
	itemList: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({}))]),
	activeLabel: PropTypes.string,
	headerText: PropTypes.string
};

export default PspIndexCountDropdown;
